// React Dependencies
import React, { Component } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { TextField, Typography, Chip, Paper, Tabs, Tab, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, FormControlLabel, Checkbox } from '@material-ui/core';

// Internal Dependencies
import { getAddress } from '../../../actions/admin/address';
import TransferList from './transferList';
import CustomList from './customList';
import { Trim } from '../../../common/util';
import { IsEmpty, IsTrue } from '../../../common/checks';
import Constants, { PageType } from '../../../common/constants';

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  textHeader: {
    marginLeft: theme.spacing(0.5),
  },
  textField: {
    marginLeft: theme.spacing(0.5),
    width:      '100%',
  },
});

class Availability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: {
        ...props.page,
        locations: (props.page.type === PageType.AreaManagement) ? props.partnerBuildings : props.page.locations,
      },
      postId:              props.postId,
      promoAvailOnlineAt:  props.promoAvailOnlineAt,
      promoLocations:      props.promoLocations,
      noOfCustomLocations: 0,
      isAvailOnline:       this.props.isAvailOnline,
      tab:                 0,
      address:             '',
      lat:                 '',
      lng:                 '',
      postalCode:          '',
      remarks:             '',
      locatedIn:           '',
      modalType:           'Add',
      open:                false,
      selectedLocation:    '',
      tableData:           '',
      errorPostalCode:     true,
    };
  }

  componentDidMount() {
    const customLocations = this.props.promoLocations.filter((location) => location.outletId === null || location.outletId === '');
    this.setState({ noOfCustomLocations: !IsEmpty(customLocations) ? customLocations.length : 0 });
  }

  onChangeFields = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.name === 'promoAvailOnlineAt') {
      if (event.target.value.length > 0) {
        this.setState({ isAvailOnline: true });
      } else {
        event.target.value = '';
        this.setState({ isAvailOnline: false }, () => {
          this.props.onAvailOnlineChanged(this.state.isAvailOnline);
        });
      }
      this.props.onPromoAvailOnlineAtChanged(event.target.value);
    }
  }

  onChangePostalCode = (e) => {
    this.setState({ postalCode: Trim(e.target.value) },
      async () => {
        const { postalCode } = this.state;
        if (postalCode.length === 6) {
          this.setState({ address: '.....' });
          const result = await this.props.getAddress(postalCode);

          let address; let lat; let lng; let
            locatedIn;
          if (result !== null && typeof result === 'object') {
            lat = IsEmpty(result.lat) ? '' : result.lat;
            lng = IsEmpty(result.lng) ? '' : result.lng;
            address = IsEmpty(result.address) ? Constants.Error.PostalCodeIsInvalid : result.address;
            locatedIn = IsEmpty(result.name) ? '' : result.name;

            this.setState({ errorPostalCode: false });
          } else {
            address = Constants.Error.PostalCodeIsInvalid;
            lat = '';
            lng = '';
            locatedIn = '';

            this.setState({ errorPostalCode: true });
          }
          this.setState({ address, lat, lng, locatedIn });
        } else {
          this.setState({ address: Constants.Error.PostalCodeIsInvalid, locatedIn: '', errorPostalCode: true });
        }
      });
  }

  onChangePromoIsNationwide = (bool) => {
    this.props.onPromoIsNationwideChanged(bool);
  }

  onChangeTab = (event, newValue) => {
    this.setState({ tab: newValue });
  };

  onCloseModal = () => {
    this.setState({ open: false });
    this.handleReset();
  }

  onOpenModal = (type, tableData, selectedLocation) => {
    if (type === 'Add') {
      this.setState({ open: true, modalType: 'Add' });
    }
    if (type === 'Update') {
      this.setState({
        open:            true,
        modalType:       'Update',
        postalCode:      selectedLocation.postalCode,
        address:         selectedLocation.address,
        lat:             selectedLocation.lat,
        lng:             selectedLocation.lng,
        locatedIn:       selectedLocation.locatedIn,
        remarks:         selectedLocation.remarks,
        tableData,
        selectedLocation,
        errorPostalCode: false,
      });
    }
  }

  handleReset = () => {
    this.setState({ postalCode: '', address: '', lat: '', lng: '', remarks: '' });
  }

  handleSubmit = () => {
    if (this.state.modalType === 'Add') {
      if (this.state.address === Constants.Error.PostalCodeIsInvalid) {
        toast.error('Postal code is invalid.');
        this.handleReset();
        return;
      }
      if (this.state.promoLocations.some((location) => location.postalCode === this.state.postalCode && location.outletId === null)) {
        toast.error('Custom location already exists.');
        this.onCloseModal();
        return;
      }
      const location = {
        postId:     this.state.postId,
        outletId:   null,
        address:    this.state.address,
        postalCode: this.state.postalCode,
        remarks:    this.state.remarks,
        lat:        this.state.lat,
        lng:        this.state.lng,
        location:   null,
        locatedIn:  Trim(this.state.locatedIn, false, true),
      };
      this.setState({ promoLocations: this.state.promoLocations.concat(location) },
        () => {
          this.props.onPromoLocationsChanged(this.state.promoLocations);
        });
      this.onCloseModal();
    } else {
      const { tableData } = this.state; const
        { selectedLocation } = this.state;
      const index = tableData.findIndex((location) => location.tableData.id === selectedLocation.tableData.id);
      const object = tableData[index];
      object.locatedIn = Trim(this.state.locatedIn, false, true);
      object.address = this.state.address;
      object.lat = this.state.lat;
      object.lng = this.state.lng;
      object.postalCode = this.state.postalCode;
      object.remarks = this.state.remarks;
      this.onCloseModal();
    }
  }

  handleDeleteCustomLocation = (tableData, selectedLocation) => {
    this.setState({
      tableData,
      selectedLocation,
    }, () => {
      /* Remove Table (Copy) Entries Not Selected */
      _.remove(this.state.tableData, (location) => location.tableData.id !== this.state.selectedLocation.tableData.id);
      /* Fetch Difference: Remove Selected Location*/
      this.setState({ promoLocations: _.difference(this.state.promoLocations, this.state.tableData) },
        () => {
          this.props.onPromoLocationsChanged(this.state.promoLocations);
        });
    });
  }

  handleAddPromoLocations = (data) => {
    this.setState({ promoLocations: data },
      () => {
        this.props.onPromoLocationsChanged(this.state.promoLocations);
      });
  }

  handleIsAvailableOnline = (state) => {
    this.setState({ isAvailOnline: !state }, () => {
      if (!IsTrue(this.state.isAvailOnline)) {
        this.setState({ promoAvailOnlineAt: '' }, () => {
          this.props.onPromoAvailOnlineAtChanged('');
        });
      }
      this.props.onAvailOnlineChanged(this.state.isAvailOnline);
    });
  }

  render() {
    const { classes, promoLocations } = this.props;
    const { address, modalType, open, page, postId, postalCode, locatedIn, remarks, tab, promoAvailOnlineAt } = this.state;
    const { onChangeFields, onChangePostalCode, onChangePromoIsNationwide, onChangeTab, onCloseModal, onOpenModal,
      handleAddPromoLocations, handleSubmit, handleDeleteCustomLocation } = this;
    const { Mall, View, CreditCard, ECommerce, HawkerCentre, AreaManagement } = Constants.PageType;
    const whiteListPageType = [Mall, View, CreditCard, ECommerce, HawkerCentre];

    return (
      <div>
        <Chip
          variant="outlined"
          style={{ marginBottom: 10 }}
          size="small"
          label={<Typography variant="subtitle2">Online</Typography>}
        />
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col">
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={() => this.handleIsAvailableOnline(this.state.isAvailOnline)}
                  checked={this.state.isAvailOnline}
                />
              )}
              label="Available Online"
            />
            { this.props.isAvailOnline && (
              <TextField
                name="promoAvailOnlineAt"
                autoComplete="off"
                placeholder="https://www.abc.com/"
                className={classes.textField}
                value={promoAvailOnlineAt}
                onChange={(e) => onChangeFields(e)}
              />
            ) }
            {
              this.props.isAvailOnline && !IsEmpty(promoAvailOnlineAt) && !String(promoAvailOnlineAt).startsWith('https')
              && <Typography className="ml-3" variant="subtitle1" color="inherit" style={{ color: 'red' }}>*Url must start with &apos;https&apos;</Typography>
            }
          </div>
        </div>
        <Chip
          variant="outlined"
          style={{ marginBottom: 10 }}
          size="small"
          label={<Typography variant="subtitle2">Offline</Typography>}
        />
        <div>
          {!whiteListPageType.includes(page.type)
            ? (
              <div>
                <Paper className={classes.root}>
                  <Tabs
                    value={tab}
                    onChange={onChangeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    <Tab label={page.type === AreaManagement ? 'Partner Buildings' : 'Outlets'} />
                    <Tab label={`Custom Locations (${!IsEmpty(this.state.noOfCustomLocations) ? this.state.noOfCustomLocations : 0})`} />
                  </Tabs>
                </Paper>
                {tab === 0
                  ? (
                    <TransferList
                      page={page}
                      postId={postId}
                      promoLocations={promoLocations}
                      onChangePromoIsNationwide={onChangePromoIsNationwide}
                      handleAddPromoLocations={handleAddPromoLocations}
                      itemText={page.type === AreaManagement ? 'Building' : 'Outlet'}
                    />
                  ) : ''}
                {tab === 1
                  ? (
                    <div>
                      &nbsp;
                      <div>
                        <Button variant="outlined" color="primary" onClick={() => { onOpenModal('Add'); }}>Add Location</Button>
                      </div>
                      &nbsp;
                      <div>
                        <CustomList
                          page={page}
                          promoLocations={promoLocations}
                          onOpenModal={onOpenModal}
                          handleDeleteCustomLocation={handleDeleteCustomLocation}
                          updateCustomLocationCount={(count) => this.setState({ noOfCustomLocations: count })}
                        />
                      </div>
                    </div>
                  ) : ''}
              </div>
            )
            : (
              <>
                <div className="mt-3">
                  <Button variant="outlined" color="primary" onClick={() => { onOpenModal('Add'); }}>Add Location</Button>
                </div>
                <div>
                  <CustomList
                    page={page}
                    promoLocations={promoLocations}
                    onOpenModal={onOpenModal}
                    handleDeleteCustomLocation={handleDeleteCustomLocation}
                  />
                </div>
              </>
            )}
        </div>
        <Dialog
          fullWidth
          size="sm"
          open={open}
          onClose={onCloseModal}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {modalType}
            {' '}
            Location
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="postalCode"
              name="postalCode"
              label="Postal Code"
              placeholder="e.g. 039594"
              value={postalCode}
              onChange={(e) => onChangePostalCode(e)}
              fullWidth
            />
            <TextField
              disabled
              margin="dense"
              id="locatedIn"
              name="locatedIn"
              label="Located In"
              value={locatedIn}
              fullWidth
            />
            <TextField
              disabled
              margin="dense"
              id="address"
              name="address"
              label="Address"
              value={address}
              fullWidth
            />
            <TextField
              multiline
              margin="dense"
              id="remarks"
              name="remarks"
              label="Remarks"
              placeholder="e.g. 03-44, Level 1 Atrium, Roof Garden"
              value={remarks}
              onChange={(e) => onChangeFields(e)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onCloseModal} color="primary">Cancel</Button>
            <Button onClick={handleSubmit} color="primary" disabled={this.state.errorPostalCode}>{modalType}</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Availability.propTypes = {
  classes:            PropTypes.shape.isRequired,
  postId:             PropTypes.number.isRequired,
  page:               PropTypes.shape.isRequired,
  promoAvailOnlineAt: PropTypes.arrayOf(PropTypes.shape).isRequired,
  promoLocations:     PropTypes.arrayOf(PropTypes.shape).isRequired,
  isAvailOnline:      PropTypes.bool.isRequired,
  partnerBuildings:   PropTypes.arrayOf(PropTypes.shape).isRequired,

  onAvailOnlineChanged:        PropTypes.func.isRequired,
  onPromoAvailOnlineAtChanged: PropTypes.func.isRequired,
  getAddress:                  PropTypes.func.isRequired,
  onPromoIsNationwideChanged:  PropTypes.func.isRequired,
  onPromoLocationsChanged:     PropTypes.func.isRequired,
};

export default connect(null, { getAddress })(withStyles(useStyles)(Availability));
